import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import Logs from './Logs';
import StudentsTable from './StudentsTable';
import { useSchool } from 'hooks/useBeneficiaries';

const SchoolDetails = () => {
  const { id } = useParams();

  const { school } = useSchool(id);

  // TODO: Contact data needs to be migrated to Supabase
  const contactData = null;

  return (
    <Fragment>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="fw-bold">School Details</h4>}
          light={false}
          titleTag="div"
          className="pb-1"
          menuClassName="align-items-start"
        />

        <Card.Body>
          <Row>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Serial Number</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Address</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>City</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Country</p>
                </div>
                <div>
                  <p className="mb-2 text-primary" style={{ fontSize: '1rem' }}>
                    {school?.serial_number}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>
                    {school?.school_address}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>
                    {school?.school_city}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{school?.country}</p>
                </div>
              </Flex>
            </Col>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>School Name</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Registered Date</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Email</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Documents</p>
                </div>
                <div>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>
                    {school?.school_name}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>
                    {dayjs(school?.created_at).format(
                      'MMM-DD-YYYY'
                    )}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>
                    {school?.school_email}
                  </p>
                  {school?.school_document ? (
                    <p className="mb-2" style={{ fontSize: '1rem' }}>
                      <a
                        href={school?.school_document}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        File URL{' '}
                      </a>
                    </p>
                  ) : (
                    ''
                  )}
                </div>
              </Flex>
            </Col>
          </Row>
          <hr />

          <FalconCardHeader
            title={<h4 className="fw-bold">Person To Contact</h4>}
            light={false}
            titleTag="div"
            className="p-0 pb-3"
            menuClassName="align-items-start"
          />

          <Row>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Title</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Name</p>
                </div>
                <div>
                  <p className="mb-2 text-primary" style={{ fontSize: '1rem' }}>
                    {contactData?.contact?.[0]?.title}
                  </p>
                  {contactData?.contact?.[0]?.first_name && (
                    <p className="mb-2" style={{ fontSize: '1rem' }}>{`${contactData?.contact[0]?.first_name} ${contactData?.contact[0]?.last_name}`}</p>
                  )}
                </div>
              </Flex>
            </Col>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Email</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Phone Number</p>
                </div>
                <div>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{contactData?.contact?.[0]?.email}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{contactData?.contact?.[0]?.phone}</p>
                </div>
              </Flex>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Row className="my-3">
        <Col md={12} xxl={12} className="h-md-100">
          <StudentsTable />
        </Col>
      </Row>

      <Logs moduleType="School" />
    </Fragment>
  );
};

export default SchoolDetails;
